import { createContext } from 'react';
export var CDNContext = createContext({ rootUrl: '', disableCDN: false });
